import styled from 'styled-components';

const ArchivePageWrapper = styled.div`
  position: relative;
`;

export default ArchivePageWrapper;
